//load our custom elements
require("component-responsive-frame/child");
require("component-leaflet-map");

var element = document.querySelector("leaflet-map");
var L = element.leaflet;
var map = element.map;

var ich = require("icanhaz");
var templateFile = require("./_popup.html");
ich.addTemplate("popup", templateFile);

var data = require("./property-crime.geo.json");

var element = document.querySelector("leaflet-map");
var mapElement = document.querySelector("leaflet-map");


if (mapElement) {
  var L = mapElement.leaflet;
  var map = mapElement.map;

  map.scrollWheelZoom.disable();

  var focused = false;

  var mode = "rate";
  var max;

  var getColor = function(d) {
    var value = d[mode];
    if (typeof value == "string") {
      value = Number(value.replace(/,/, ""));
    }
    // console.log(value)
    if (typeof value != "undefined") {
      // condition ? if-true : if-false;
     return value >= max * .8 ? '#9b2626' :
     		value >= max * .6 ? '#b74e4e' :
            value >= max * .4 ? '#e76349' :
            value >= max * .2 ? '#f19e7b' :
            value >= max * .1 ? '#f8cab2' : 
             '#fcefc3' ;
    } else {
      return "gray"
    }
  };

  var onEachFeature = function(feature, layer) {
  	layer.bindPopup(ich.popup(feature.properties))
    layer.on({

   	mouseover: function(e) {
        layer.setStyle({ weight: 2, fillOpacity: 1.0 });
      },
      mouseout: function(e) {
        if (focused && focused == layer) { return }
        layer.setStyle({ weight: 1.5, fillOpacity: 0.65 });
      }
    });
  };

  var style = function(feature) {
    var s = {
      fillColor: getColor(feature.properties),
      weight: 1.5,
      opacity: .25,
      color: '#000',
      fillOpacity: 0.65
    };
    return s;
  }

  var geojson = L.geoJson(data, {
    style: style,
    onEachFeature: onEachFeature
  }).addTo(map);

var controls = document.querySelector(".radio-block");

var onChange = function() {
  //find the radio button that's currently checked
  var value = document.querySelector(`input[name="class"]:checked`).id;
  mode = value;
  max = Math.max.apply(null, data.features.map(f => f.properties[mode]));
  var legend = document.querySelector(".legend");
  legend.innerHTML = `
  	<li><span style="background: #9b2626" class="block"></span> ${(max * .8)+1 | 0} or more crimes</li>
  	<li><span style="background: #b74e4e" class="block"></span> ${(max * .6)+1 | 0} - ${(max * .8) | 0}</li>
  	<li><span style="background: #e76349" class="block"></span> ${(max * .4)+1 | 0} - ${(max * .6) | 0}</li>
  	<li><span style="background: #f19e7b" class="block"></span> ${(max * .2)+1 | 0} - ${(max * .4) | 0}</li>
  	<li><span style="background: #f8cab2" class="block"></span> ${(max * .1)+1 | 0} - ${(max * .2) | 0}</li>
  	<li><span style="background: #fcefc3" class="block"></span> 0 - ${(max * .1) | 0}</li>
  `;
  console.log(legend);
  geojson.setStyle(style);
};

controls.addEventListener("change", onChange);
onChange(); 

}

var onEachFeature = function(feature, layer) {
  layer.bindPopup(ich.popup(feature.properties))
};


 map.scrollWheelZoom.disable();